// public/js/components/checkbox.js

const CLASSES = {
  invalid: ['border-red-600', 'bg-red-50'],
  neutral: ['border-slate-200', 'hover:bg-slate-50'],
  // We leave the 'checked' teal styles to CSS (:checked selector), 
  // but we remove invalid styles when valid.
};

export default function Checkbox(rootEl) {
  const input = rootEl.querySelector('input[type="checkbox"]');
  const container = rootEl.querySelector('[data-ref="container"]');
  const errorDiv = rootEl.querySelector('[data-ref="error"]');

  if (!input || !container) return;

  const setVisualState = (state, message = '') => {
    // 1. Toggle Error Message
    if (errorDiv) {
      errorDiv.textContent = message;
      if (message) errorDiv.classList.remove('hidden');
      else errorDiv.classList.add('hidden');
    }

    // 2. Toggle Classes on Container
    // Always remove invalid classes first
    container.classList.remove(...CLASSES.invalid);

    if (state === 'invalid') {
      // Remove neutral styles to avoid clashes
      container.classList.remove(...CLASSES.neutral);
      container.classList.add(...CLASSES.invalid);
      input.setAttribute('aria-invalid', 'true');
    } else {
      // Restore neutral styles (CSS handles the rest for checked state)
      container.classList.add(...CLASSES.neutral);
      input.setAttribute('aria-invalid', 'false');
    }
  };

  const validate = () => {
    const isRequired = input.hasAttribute('required');
    
    // If required and NOT checked, fail validation
    if (isRequired && !input.checked) {
      setVisualState('invalid', 'You must agree to continue.');
      return false;
    }

    setVisualState('valid');
    return true;
  };

  // Expose validate method for main.js
  rootEl.validate = validate;

  // Listeners
  input.addEventListener('change', () => {
    // Clear error immediately on interaction
    setVisualState('valid');
  });

  input.addEventListener('invalid', (e) => {
    e.preventDefault(); // Stop default browser bubble
    validate();
  });
}